import { Component, ViewChild } from '@angular/core';
import { User } from './user/_models/user.model';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { AuthenticationService } from './user/_services/authentication.service';
import { environment } from 'src/environments/environment';
import { FORM_MSGS, PRODUCT_CONFIG } from 'src/app/_common/product-config';

import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import LogRocket from 'logrocket';
import { HeaderData } from './_models/header-data';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'PSI-PSOP-FrontEnd-AngularWebApp';
  currentUser: User;

  displayHeader: boolean = false;
  onDashboard: boolean = false;

  modalReference;
  idleState = 'Not started.';
  timeoutModalShown = false;
  timedOut = false;
  lastPing?: Date = null;
  autoRefreshInterval = null;


  @ViewChild("sessionTimeoutModal", {static: false}) sessionTimeoutModal;
  
  constructor(private router:Router,
    private authenticationService: AuthenticationService,
    private modalService : NgbModal, 
    private idle: Idle) {
      
      // sets an idle timeout of 1680 seconds (28 Minutes), for testing purposes.
      idle.setIdle(PRODUCT_CONFIG.IdleTimeoutSeconds);
      // sets a timeout period of 120 seconds (2 Minutes). after 1800 seconds (30 Minutes) of inactivity, the user will be considered timed out.
      idle.setTimeout(PRODUCT_CONFIG.IdleDialogSeconds);
      // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
      idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      idle.onIdleEnd.subscribe(() => {
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
        this.idleState = 'No longer idle.';
        if(environment.logRocketKey){
          LogRocket.log("No longer idle");
        }else{
          console.log("No longer idle");
        }
        this.resetTimeout();
      });
      idle.onTimeout.subscribe(() => {
        this.idleState = 'Timed out!';
        let pipe = new DatePipe('en-US');
        if(environment.logRocketKey){
          LogRocket.log("Timed out! at " + pipe.transform(new Date(), 'MM/dd/yyyy, h:mm:ss a'));
        }else{
          console.log("Timed out! at " + pipe.transform(new Date(), 'MM/dd/yyyy, h:mm:ss a'));
        }
        this.timedOut = true;
        this.logout();
      });
      idle.onIdleStart.subscribe(() => {
        let pipe = new DatePipe('en-US');
        this.idleState = 'You\'ve gone idle!';
        if(environment.logRocketKey){
          LogRocket.log("You've gone idle at " + pipe.transform(new Date(), 'MM/dd/yyyy, h:mm:ss a'));
        }else{
          console.log("You've gone idle at " + pipe.transform(new Date(), 'MM/dd/yyyy, h:mm:ss a'));
        }
        this.timeoutModalShown = true;
        this.openSessionTimeoutModal();
      });
      idle.onTimeoutWarning.subscribe((countdown) =>{
        this.idle.clearInterrupts();
        this.idleState = 'You will time out in ' + countdown + ' seconds!'; 
        if(environment.logRocketKey){
          LogRocket.log('You will time out in ' + countdown + ' seconds!');
        }else{
          console.log('You will time out in ' + countdown + ' seconds!');
        }
      });

      //this.resetTimeout();
      this.authenticationService.getUserLoggedIn().subscribe(userLoggedIn => {
        if(userLoggedIn){
          let pipe = new DatePipe('en-US');
          if(environment.logRocketKey){
            LogRocket.log("idle watch started at " + pipe.transform(new Date(), 'MM/dd/yyyy, h:mm:ss a'));
          }else{
            console.log("idle watch started at " + pipe.transform(new Date(), 'MM/dd/yyyy, h:mm:ss a'));
          }
          idle.watch();
          this.timedOut = false;

          if(this.autoRefreshInterval){
            clearInterval(this.autoRefreshInterval);
          }
          this.autoRefreshInterval = setInterval(()=>{
            this.autoRefreshToken();
          }, PRODUCT_CONFIG.autoRefreshTokenMiliSeconds)
        } else {
          if(this.autoRefreshInterval){
            clearInterval(this.autoRefreshInterval);
          }
          if(environment.logRocketKey){
            LogRocket.log("idle watch stopped");
          }else{
            console.log("idle watch stopped");
          }
          idle.stop();
        }
      });

      /************************************************************ */
      console.log("Version: " + environment.version);

      this.currentUser = this.authenticationService.currentUser;
      if(environment.logRocketKey){
        LogRocket.init(environment.logRocketKey, {
          release: environment.version,
          network: {
            requestSanitizer: (request:any) => {
              // if the url contains 'ignore'
              if (request.url.toLowerCase().indexOf('resetpassword') !== -1) {
                // ignore the request response pair
                return null;
              }

              if (request.url.toLowerCase().indexOf('signin') !== -1 || request.url.toLowerCase().indexOf('user/change') !== -1) {
                // ignore the request body
                request.body = null;
              }
              
              // otherwise log the request normally
              return request;
            },
          },
        });
        if(this.currentUser){
          LogRocket.identify(this.currentUser.UID.toString(), {
            userName: this.currentUser.email,
            name: `${this.currentUser.firstName} ${this.currentUser.lastName}`,
            companyName: this.currentUser.companyName,
            companyId: this.currentUser.companyID,
            userType: this.currentUser.userType,
            userRole: this.currentUser.userRole
          });
        }
      }

      this.router.events.forEach((event) => {
        if (event instanceof NavigationStart) {
          window.scrollTo(0,0);
        }
        if (event instanceof NavigationEnd) {
          this.authenticationService.header = new HeaderData();
          this.displayHeader = this.authenticationService.currentUser && !(event['url'].includes('/login')) && !(event['url'].includes('/verify')) && !(event['url'].includes('/activation')) && !(event['url'].includes('/loading'));
          this.onDashboard = (event['url'] === '/' || event['url'] === ('/dashboard'));
        }
      });

      if(!environment.consoleLog || environment.consoleLog.toString() == "false"){
        console.log = function(){};
      }
    }

    ngAfterViewInit(){
      /* do not change number field value when scrolling */
      document.addEventListener("wheel", function(){
        let active:any = document.activeElement;
        if(active.type === "number"){
          active.blur();
        }
      });
    }

    autoRefreshToken(){
      let refreshTokenSubscription = this.authenticationService.refreshToken(false).subscribe(data=>{
      });
      this.authenticationService.runningServices.push(refreshTokenSubscription);
    }
    
    logout() {
      this.idle.stop();
      this.authenticationService.logout().subscribe(data => {
        this.modalReference.close();
        if(this.timedOut){
          this.router.navigate(['/login'], {state: {warningMessage: FORM_MSGS.SessionTimeout}});
        }else{
          this.router.navigate(['/login']);
        }
      },error=>{
        this.authenticationService.removeData();
        this.modalReference.close();
        if(this.timedOut){
          this.router.navigate(['/login'], {state: {warningMessage: FORM_MSGS.SessionTimeout}});
        }else{
          this.router.navigate(['/login']);
        }
      });
    }
    private stayLoggedIn(){ //Calling from HTML
      this.authenticationService.refreshToken().subscribe(data=>{
        this.resetTimeout();
      })
    }
    private resetTimeout() {
      this.idle.stop();
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      this.idle.watch();
      this.idleState = 'Started.';
      console.log(this.idleState);
      this.timedOut = false;
    }

    private openSessionTimeoutModal(){
      this.modalReference = this.modalService.open(this.sessionTimeoutModal, { centered: false, backdropClass: 'light-blue-backdrop' });
      this.modalReference.result.then((result) => {
      }, (reason) => {
      });
    }
}
